import Users from "@/pages/Users/Users";
import React from "react";
import type { RouteConfig } from "@/types/routestypes";
import DashboardIcon from "@/components/SVGComponents/DashboardIcon";
import UserIcon from "@/components/SVGComponents/UserIcon";
import ApplicationErrorLogsIcon from "@/components/SVGComponents/ApplicationErrorLogsIcon";
import PaymentsIcon from "@/components/SVGComponents/PaymentsIcon";
import ReportsIcon from "@/components/SVGComponents/ReportsIcon";
import AdminManagementIcon from "@/components/SVGComponents/AdminManagementIcon";
import ActivityIcon from "@/components/SVGComponents/ActivityIcon";
const SignUp = React.lazy(() => import("@/pages/SignUp/SignUp"));
const Login = React.lazy(() => import("@/pages/Login/Login"));
const ForgotPassword = React.lazy(
  () => import("@/pages/ForgotPassword/ForgotPassword")
);
const ForgotPasswordOtp = React.lazy(
  () => import("@/pages/OtpVerification/ForgotPasswordOtp/ForgotPasswordOtp")
);
const ResetLinkSent = React.lazy(
  () => import("@/pages/ForgotPassword/ResetLinkSent/ResetLinkSent")
);
const CreatePassword = React.lazy(
  () => import("@/pages/CreatePassword/CreatePassword")
);
const Dashboard = React.lazy(() => import("@/pages/Dashboard/Dashboard"));
const ApplicationErrorLogs = React.lazy(
  () => import("@/pages/ApplicationErrorLogs/ApplicationErrorLogs")
);
const Payments = React.lazy(() => import("@/pages/Payments/Payments"));
const UserDetails = React.lazy(() => import("@/pages/UserDetails/UserDetails"));
const ErrorLogDetail = React.lazy(
  () => import("@/pages/ErrorLogDetail/ErrorLogDetail")
);
const Reports = React.lazy(() => import("@/pages/Reports/Reports"));
const AdminManagement = React.lazy(
  () => import("@/pages/AdminManagement/AdminManagement")
);
const EmailAnalytics = React.lazy(
  () => import("@/pages/EmailAnalytics/EmailAnalytics")
);

const routes: {
  publicRoutes: Record<string, { path: string; element: React.ReactElement }>;
  privateRoutes: Record<string, RouteConfig>;
} = {
  publicRoutes: {
    LOGIN: {
      path: "/login",
      element: <Login />,
    },
    CREATE_PASSWORD: {
      path: "/create-password",
      element: <CreatePassword />,
    },
    SIGN_UP: {
      path: "/sign-up",
      element: <SignUp />,
    },
    FORGOT_PASSWORD: {
      path: "/forgot-password",
      element: <ForgotPassword />,
    },
    // OTP_VERIFICATION: {
    //   path: "/otp-verification",
    //   element: <OtpVerification />,
    // },
    RESET_LINK_SENT: {
      path: "/reset-link-sent",
      element: <ResetLinkSent />,
    },
    EMAIL_VERIFICATION: {
      path: "/email-verification",
      element: <ForgotPasswordOtp heading="Verify your email!" />,
    },
  },
  privateRoutes: {
    DASHBOARD: {
      path: "/dashboard",
      element: <Dashboard />,
      pageName: "Dashboard",
      sidebar: {
        show: true,
        icon: DashboardIcon,
      },
      permissionName: "get user list",
    },
    USERS: {
      path: "/users",
      element: <Users />,
      pageName: "Users",
      sidebar: {
        show: true,
        icon: UserIcon,
      },
      permissionName: "get user list",
    },
    USER_DETAILS: {
      path: "/users/:id",
      element: <UserDetails />,
      pageName: "User Details",
      permissionName: "get user list",
    },
    APPLICATION_ERROR_LOGS: {
      path: "/application-error-logs",
      element: <ApplicationErrorLogs />,
      pageName: "Application Error Logs",
      sidebar: {
        show: true,
        icon: ApplicationErrorLogsIcon,
      },
      permissionName: "get user list",
    },
    ERROR_LOG_DETAIL: {
      path: "/application-error-logs/:issueId",
      element: <ErrorLogDetail />,
      pageName: "Error Detail",
      permissionName: "get user list",
    },
    PAYMENTS: {
      path: "/payments",
      element: <Payments />,
      pageName: "Payments",
      sidebar: {
        show: true,
        icon: PaymentsIcon,
      },
      permissionName: "get user list",
    },
    REPORTS: {
      path: "/reports",
      element: <Reports />,
      pageName: "Reports",
      sidebar: {
        show: true,
        icon: ReportsIcon,
      },
      permissionName: "get user list",
    },
    ADMIN_MANAGEMENT: {
      path: "/admin-management",
      element: <AdminManagement />,
      pageName: "Admin Management",
      sidebar: {
        show: true,
        icon: AdminManagementIcon,
      },
      permissionName: "get user list",
    },
    EMAIL_ANALYTICS: {
      path: "/email-analytics",
      element: <EmailAnalytics />,
      pageName: "Email Analytics",
      sidebar: {
        show: true,
        icon: ActivityIcon,
      },
      permissionName: "get user list",
    },
  },
} as const;

export default routes;
